import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef
} from '@angular/material/dialog';
import { fetchAuthSession } from 'aws-amplify/auth';
import { environment } from 'src/environments/environment';
import { SERVICE_TYPES } from '../../service-types';
@Component({
  selector: 'app-dialog-confirm',
  templateUrl: './dialog-confirm.component.html',
  styleUrls: ['./dialog-confirm.component.css']
})
export class DialogConfirmComponent implements OnInit {
  loading: boolean = false;
  success: boolean = false;
  s3ServiceRoute: any = `${environment.operationsApi}/api/v1`;

  constructor(
    public dialogRef: MatDialogRef<DialogConfirmComponent>,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private http: HttpClient
  ) {}

  ngOnInit(): void {}

  private async getAuthHeaders(): Promise<HttpHeaders> {
    try {
      const session = await fetchAuthSession();
      const token = session.tokens?.idToken?.toString();

      return new HttpHeaders({
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      });
    } catch (error) {
      console.error('Error getting auth token:', error);
      return new HttpHeaders({
        'Content-Type': 'application/json'
      });
    }
  }

  async onSave() {
    if (!this.loading) {
      this.loading = true;
      let deleted;

      try {
        const headers = await this.getAuthHeaders();

        if (this.data.serviceType == 1) {
          deleted = this.http.delete(
            `${this.s3ServiceRoute}/deleteFile/${this.data.mediaElement.key}`,
            { headers }
          );
        } else if (this.data.serviceType === 2) {
          deleted = this.http.delete(
            `${this.s3ServiceRoute}/deleteFileTransporte/${this.data.mediaElement.key}`,
            { headers }
          );
        } else if (this.data.serviceType == 3) {
          deleted = this.http.delete(
            `${this.s3ServiceRoute}/deleteFileTren/${this.data.mediaElement.key}`,
            { headers }
          );
        } else if (this.data.serviceType == 4) {
          deleted = this.http.delete(
            `${this.s3ServiceRoute}/deleteFileGuias/${this.data.mediaElement.key}`,
            { headers }
          );
        } else if (this.data.serviceType == 5) {
          deleted = this.http.delete(
            `${this.s3ServiceRoute}/deleteFileOperadores/${this.data.mediaElement.key}`,
            { headers }
          );
        } else if (this.data.serviceType == 6) {
          deleted = this.http.delete(
            `${this.s3ServiceRoute}/deleteFileTransporte/${this.data.mediaElement.key}`,
            { headers }
          );
        } else if (this.data.serviceType == 7) {
          deleted = this.http.delete(
            `${this.s3ServiceRoute}/deleteFileHoteles/${this.data.mediaElement.key}`,
            { headers }
          );
        } else if (this.data.serviceType == 10) {
          deleted = this.http.delete(
            `${this.s3ServiceRoute}/deleteFileItinerary/${this.data.mediaElement.key}`,
            { headers }
          );
        } else if (this.data.serviceType == 11) {
          deleted = this.http.delete(
            `${this.s3ServiceRoute}/deleteFileTemplate/${this.data.mediaElement.key}`,
            { headers }
          );
        } else if (this.data.serviceType === SERVICE_TYPES.TICKET) {
          deleted = this.http.delete(
            `${this.s3ServiceRoute}/deleteFileTicket/${this.data.mediaElement.key}`,
            { headers }
          );
        } else {
          deleted = this.http.delete(
            `${this.s3ServiceRoute}/deleteFileCoordinadores/${this.data.mediaElement.key}`,
            { headers }
          );
        }

        deleted.subscribe({
          next: (response: any) => {
            this.success = true;
            this.loading = false;
            if (
              this.data.updateHasDocument &&
              this.data.multimediaCant &&
              this.data.multimediaCant - 1 <= 0
            ) {
              console.log('this.data.multimediaCant', this.data);
              this.data.updateHasDocument(this.data.generalId, false);
            }
            this.OnClose();
          },
          error: (e: any) => {
            this.success = false;
            this.loading = false;

            this.OnClose();
          }
        });
      } catch (error) {
        console.error('Error al eliminar archivo:', error);
        this.success = false;
        this.loading = false;
      }
    }
  }

  OnClose() {
    this.dialogRef.close({
      success: this.success
    });
  }
  onCancel() {
    this.OnClose();
  }

  ngOnDestroy(): void {
    this.OnClose();
  }
}
